import React from 'react';
import Layout from '../components/layout';
import SEO from '../components/seo';

const NotFound = () => (
    <Layout>
        <SEO title="404 Not Found" />
        <div className="not-found">
            <div className="not-found-text">That page does not exist</div>
            <div className="not-found-link">
                <a href="/">Let's take you to the homepage</a>
            </div>
        </div>
    </Layout>
);

export default NotFound;
